// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_ESHOP_PRODUCT_SHORT = "ESHOP";
export const BZ2_NEW_PRODUCT_HOVER = "Nov\u00e9 zbo\u017e\u00ed";
export const BZ2_OLD_PRODUCT_HOVER = "Pou\u017eit\u00e9 zbo\u017e\u00ed";
export const counter_RATINGS = ["%(counter)s hodnocen\u00ed", "%(counter)s hodnocen\u00ed", "%(counter)s hodnocen\u00ed"];
export const FROM = "Od";
export const PRODUCT_BOX_MARKET_BUTTON_LABEL = "Kde k\u00fapim";
export const PRODUCT_BOX_WRITE_REVIEW = "Nap\u00ed\u0161 hodnocen\u00ed";
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prvn\u00ed a napi\u0161 hodnocen\u00ed";
